import slice from "./authSlice";

export default slice.reducer;
